import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useCourseDetail } from '@/store';
import { ECourseContentStep, ECourseStep } from '@/types';

export const useBaseCourseTabs = () => {
  const navigateTo = useNavigate();
  const { courseId } = useCourseDetail();
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');
  const items = useMemo(
    () => [
      {
        key: ECourseStep.CONTENT,
        label: t(ECourseStep.CONTENT),
        subMenuItems: [
          {
            key: ECourseContentStep.INTRODUCTION,
            label: t(ECourseContentStep.INTRODUCTION)
          },
          {
            key: ECourseContentStep.SECTIONS,
            label: t(ECourseContentStep.SECTIONS)
          }
        ]
      },
      {
        key: ECourseStep.TASKS_PANEL,
        label: t(ECourseStep.TASKS_PANEL)
      },
      {
        key: ECourseStep.QUIZZES,
        label: t(ECourseStep.QUIZZES)
      }
    ],
    [t]
  );

  const { pathname, search } = useLocation();

  const activeTab = new URLSearchParams(search).get('activeTab');

  const handleTabChange = (key: string) => {
    if (key === ECourseStep.CONTENT) return;

    navigateTo({
      pathname,
      search: `?activeTab=${key}`
    });
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (!activeTab) {
      navigateTo({
        pathname,
        search: `?activeTab=${ECourseStep.CONTENT}&contentTab=${ECourseContentStep.INTRODUCTION}`
      });
    }
  }, [search]);

  return {
    activeTab,
    handleTabChange,
    items,
    courseId
  };
};
